import { render, staticRenderFns } from "./SRadio.vue?vue&type=template&id=64edd8aa&scoped=true&"
import script from "./SRadio.vue?vue&type=script&lang=ts&"
export * from "./SRadio.vue?vue&type=script&lang=ts&"
import style0 from "./SRadio.vue?vue&type=style&index=0&id=64edd8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64edd8aa",
  null
  
)

export default component.exports